import moment from "moment";

export const parseDate = (value) => {
    if (!value) return value
    return moment.utc(value).local().format('DD.MM.YYYY HH:mm:ss')
}